import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import annex6Actions, {
    EAnnex6Actions,
    EAnnex6Constants,
    TANNEX6Actions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TAnnex6BackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const annex6HistoryMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TANNEX6Actions | IAuthActions) => {
        switch (action.type) {
            case EAnnex6Actions.HISTORY_LOAD: {
                next(action);
                const job = jobActions(EAnnex6Constants.FEATURE, action.type);
                const { providedFilters: filters } = action.payload;
                dispatch(annex6Actions.document.setFilter(filters));
                dispatch(
                    apiActions.apiRequest<{ logs: { docs: TAnnex6BackendRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
                        url: EAnnex6Constants.API,
                        queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.ANNEX6,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
						},
                        preExecute() {
                            dispatch(job.active({}));
                        },
                        postExecute: {
                            onSuccess({ data }) {
								const annex6Records = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.ANNEX6
								);
								dispatch(
									annex6Actions.document.historySet(
										commonUtils.arrayToObject(annex6Records)
									)
								);
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default: {
                next(action);
                break;
            }
        }
    };
export default annex6HistoryMiddleware;
